export default __webpack_public_path__ + "static/media/Mail.d4a32f2d.svg";